import axios from 'axios'
import constants from '../constants'

const STATS_PATH = constants.urlPrefix + '/api/stats'
const BUCKETS_PATH = STATS_PATH + '/buckets'

const getBucketsCount = () => axios.get(BUCKETS_PATH + '/count')

const countCustomerDesigns = (from, to)  => axios.get(STATS_PATH + '/designs/customers', { params: { from, to }})

const countVisitorDesigns = (from, to, category)  => axios.get(STATS_PATH + '/designs/visitors', { params: { from, to, category }})

const countTemplateUsage = (from, to, category, free)  => axios.get(STATS_PATH + '/designs/templates', { params: { from, to, category, free }})

export default {
    getBucketsCount,
    countCustomerDesigns,
    countVisitorDesigns,
    countTemplateUsage
}